// frontend/src/services/api.js
import axios from 'axios';

// Define a URL base da nossa API backend
// Usaremos uma variável de ambiente para isso, mas com um fallback para desenvolvimento
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

// Cria uma instância do Axios com a baseURL configurada
const api = axios.create({
    baseURL: API_BASE_URL,
});

// === Interceptor de Requisição ===
// Esta função será chamada ANTES de cada requisição ser enviada.
api.interceptors.request.use(
    (config) => {
        // Tenta pegar os dados do usuário (incluindo o token) do localStorage
        // (Vamos armazenar lá após o login)
        const userString = localStorage.getItem('user');
        let token = null;

        if (userString) {
            try {
                const userData = JSON.parse(userString);
                token = userData?.token; // Pega o token se existir
            } catch (e) {
                console.error("Erro ao parsear dados do usuário do localStorage", e);
                localStorage.removeItem('user'); // Limpa dados inválidos
            }
        }

        // Se temos um token, adiciona ao header 'Authorization'
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        // Retorna a configuração modificada (ou original se não houver token)
        return config;
    },
    (error) => {
        // Se ocorrer um erro durante a configuração da requisição
        return Promise.reject(error);
    }
);

// === Interceptor de Resposta (Opcional, mas útil para tratar erros 401) ===
api.interceptors.response.use(
    (response) => {
        // Se a resposta for bem-sucedida (status 2xx), apenas retorna a resposta
        return response;
    },
    (error) => {
        // Se ocorrer um erro na resposta
        if (error.response && error.response.status === 401) {
            // Erro 401 (Não Autorizado) - Token inválido, expirado ou ausente
            console.warn("Erro 401 - Não autorizado. Redirecionando para login...");
            // Limpa os dados do usuário do localStorage
            localStorage.removeItem('user');
            // Redireciona para a página de login
            // Evita redirecionamentos infinitos se já estiver no login
            if (window.location.pathname !== '/login') {
                 window.location.href = '/login'; // Redirecionamento direto
                 // Em apps mais complexos, pode-se usar o history do react-router ou um evento global
            }
            // Retorna uma promessa rejeitada para que a chamada original falhe
            return Promise.reject(new Error("Não autorizado"));
        }

        // Para outros erros, apenas rejeita a promessa para que possam ser tratados onde a chamada foi feita
        return Promise.reject(error);
    }
);


export default api; // Exporta a instância configurada do Axios